var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLangArrowIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2L1.33855 2L4.29746 5.07143L4.68493 5.07143L7.66145 2L9 2L5.10763 6L3.89237 6L0 2Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangArrowIc);
export default __webpack_public_path__ + "static/media/lang_arrow_ic.54e31773b52aa9e810249d79650de1b8.svg";
export { ForwardRef as ReactComponent };